<template>
  <div class="group-form">
    <v-alert
      v-if="contextMessage"
      type="info"
      density="comfortable"
      class="mb-3"
      variant="tonal">
      {{ contextMessage }}
    </v-alert>
    <v-text-field
      v-model="props.customState.name"
      label="Group Name"
      filled
      autofocus
      :rules="nameRules"
      clearable
      @keyup.enter="emit('submit-intent')"></v-text-field>
    <v-textarea
      v-if="showDescription"
      v-model="props.customState.description"
      label="Description (optional)"
      filled
      rows="3"
      auto-grow
      clearable></v-textarea>
  </div>
</template>
<script setup>
const props = defineProps({
  customState: { type: Object, required: true },
  showDescription: { type: Boolean, default: true },
  contextMessage: { type: String, default: '' },
});
const emit = defineEmits(['submit-intent']);
const nameRules = [
  (value) => (!!value && value.trim().length > 0) || 'Name is required',
];
</script>
<style scoped>
.group-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
